import { createAction } from '@poa/state';

export const fetchCredList = createAction('fetchCredList', () => ({}));
export const fetchUserCredList = createAction('fetchUserCredList', () => ({}));
export const fetchCredListSuccess = createAction('fetchCredListSuccess', data => ({ data }));
export const fetchCredListFailed = createAction('fetchCredListFailed', () => ({}));


export const refreshAccounts = createAction(
    'refreshAccounts',
    (
      filter_by = null,
      page = 1,
      sort_by = [],
      search = null,
      page_size = 200,
      status = null
    ) => ({ filter_by, page, sort_by, search, page_size, status })
  );
export const fetchAccountsSuccess = createAction('fetchAccountsSuccess', data => ({data}));
export const fetchAccountsFailed = createAction('fetchAccountsFailed', () => ({}));
  

export const fetchUsers = createAction('fetchUsers', ({
    account_id = null,
    cred_id = null,
}) => ({ account_id, cred_id }));

export const fetchUsersSuccess = createAction('fetchUsersSuccess', data => ({data}));
export const fetchUsersFailed = createAction('fetchUsersFailed', () => ({}));

export const saveChatJson = createAction('saveChatJson', chat_data => ({ chat_data }));

export const fetchMsgs = createAction('fetchMsgs', ({
    account_id = null,
    cred_id = null,
    user_id = null,
}) => ({ account_id, cred_id, user_id }));

export const fetchMsgsSuccess = createAction('fetchMsgsSuccess', data => ({data}));
export const fetchMsgsFailed = createAction('fetchMsgsFailed', () => ({}));